"use client"

import styled from "styled-components"
import {
  Badge,
  BigValue,
  Card,
  CardHeader,
  Subtitle,
  Title,
  TitleGroup,
  Unit,
} from "./primitives"

const pillars = [
  { label: "Environmental", score: 74, color: "var(--color-optimal)" },
  { label: "Social", score: 68, color: "var(--color-caution)" },
  { label: "Governance", score: 81, color: "var(--color-optimal)" },
]

const TopRow = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

const PillarList = styled.div`
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
`

const PillarRow = styled.div``

const PillarTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`

const PillarLabel = styled.span`
  font-size: 0.875rem;
  color: var(--color-card-foreground);
`

const PillarScore = styled.span`
  font-family: var(--font-mono);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-card-foreground);
`

const PillarTrack = styled.div`
  margin-top: 0.375rem;
  height: 0.4375rem;
  border-radius: 9999px;
  background: var(--color-muted);
  overflow: hidden;
`

const PillarFill = styled.div<{ $score: number; $color: string }>`
  height: 100%;
  border-radius: 9999px;
  width: ${(p) => p.$score}%;
  background: ${(p) => p.$color};
`

export function EsgScoreCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>ESG rating</Title>
          <Subtitle>MSCI-style composite</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">AA · Leader</Badge>
      </CardHeader>

      <TopRow>
        <BigValue>7.4</BigValue>
        <Unit>/10 overall</Unit>
      </TopRow>

      <PillarList>
        {pillars.map((p) => (
          <PillarRow key={p.label}>
            <PillarTop>
              <PillarLabel>{p.label}</PillarLabel>
              <PillarScore>{p.score}</PillarScore>
            </PillarTop>
            <PillarTrack>
              <PillarFill $score={p.score} $color={p.color} />
            </PillarTrack>
          </PillarRow>
        ))}
      </PillarList>
    </Card>
  )
}

export default EsgScoreCard
